module.exports = __webpack_public_path__ + "img/img-9.bbfda530.webp";